import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Article } from '../_interfaces/article';
import { HttpFunctionResult } from '../_interfaces/HttpFunctionResult';
import { HttpService } from './http.service';
import { TicketEmployee } from './tickets/ticket.service';
import { Attachment, AttachmentArticle } from '../_interfaces/Attachment';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(
    private http: HttpService,
    private ticketSrv: TicketEmployee.TicketService
  ) { }


  /**
   * Gibt eine Liste von Artikeln zurück
   * @param {string} searchText Text nachdem gesucht werden soll (beschreibung, EAN, Artikelnummer)
   * @param {number} limit wie viele Artikel zurückgegeben werden sollen 
   * @param {number} offset wie vile artikel übersprungen werden sollen
   * @returns {Promise<HttpFunctionResult<Article[]>>}
   */
    public async getArticles(searchText: string, limit: number = 0, offset: number = 0 ): Promise<HttpFunctionResult<Article[]>>{
      return await this.http.GET<Article[]>({
        path: `article?searchText=${encodeURIComponent(searchText)}&limit=${limit}&offset=${offset}`
      })
    }


    /**
     * Zieht eine bestimmt Anzahl dem Artikel ab, Erzeugt einen neuen Eintrag und setzt ihn auf "Zu berechnen"
     * @param {Article} article Artikel mit Anzahl die abgezogen werden soll -> ID MUSS DIE SEIN VON DER ES ABGEZOGEN WERDEN SOLL
     * @returns {Promise<HttpFunctionResult<number>>}
     */
    public async setArticlesToCalculate(article: Article): Promise<HttpFunctionResult<number>>{
      return await this.http.PUT<Article, number>({
        path: `article/${this.ticketSrv.ticket.id}/${this.ticketSrv.activeWorkstepId}`,
        body: article
      })
    }

    /**
     * Updatet ein AttachmentArticle
     * @param {AttachmentArticle} attachment anhang der bearbeitet werden soll
     * @returns 
     */
    public async updateArticleAttachment(attachment: Attachment): Promise<HttpFunctionResult<Attachment>>{
      return await this.http.PUT<Attachment, Attachment>({
        path: "article/attachment-article",
        body: attachment
      })
    }


}
